import moment from 'moment';
import axios from 'axios';
import { transactions } from '../api/anthem/api-anthem';
import * as appBrand from '../config/app-brand-config.json';
import commonStore from '../stores/commonStore';

axios.interceptors.request.use(request => {
  try {
    // Modify the requests only for Anthem Service Calls
    if (request && request.api) {
      if (request.url && request.url !== '/api/v1/proxy/anthem/v1/providerapp/logging/transactions') {
        const { userAndBrand } = commonStore;
        const transactionPrefix = userAndBrand.brand.code + appBrand.payLoadData.transactionPrefix;
        // add transaction prefix for all service calls to generate trans ID
        request.headers['X-Availity-Transaction-Prefix'] = transactionPrefix;
        // add request sent time for the service to calculate E2E time taken
        request.headers['meta-request-sent-time'] = moment().format();
      }
    }
  } catch (error) {
    window.console.log(error);
  }
  return request;
});

axios.interceptors.response.use(
  response => {
    let requestParams = '';
    try {
      // Modify the requests only for Anthem Service Calls
      if (response.config && response.config.api) {
        if (
          response.config.url &&
          response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/logging/transactions' &&
          response.config.url.toLowerCase().indexOf('anthem') > -1
        ) {
          const { userAndBrand } = commonStore;
          let transactionId = response.headers['meta-transid'];
          const appName = appBrand.payLoadData.appName;
          const channel = appBrand.payLoadData.channel;
          const interactionId = userAndBrand.user.interactionId;
          if (!transactionId) {
            transactionId =
              appBrand.payLoadData.transactionPrefix + userAndBrand.brand.code + '-' + appBrand.payLoadData.appName;
          }
          const queryParameters = {
            state: userAndBrand.brand.state,
            payer: userAndBrand.brand.payerName,
            brand: userAndBrand.brand.code,
            userId: userAndBrand.user.id,
            appName,
            channel,
            transactionId,
            interactionId,
            httpStatus: response.status,
            reqSentTime: response.config.headers['meta-request-sent-time'],
            respRcptTime: moment().format(),
            requestType: response.config.method,
            operationName: response.config.url,
          };
          if (response.config.params) {
            const isJson = typeof response.config.params === 'object';
            if (isJson) {
              requestParams = response.config.params;
            } else {
              requestParams = JSON.parse(response.config.params);
            }
          }
          if (response.config.data) {
            const isJson = typeof response.config.data === 'object';
            if (isJson) {
              requestParams = response.config.data;
            } else {
              requestParams = JSON.parse(response.config.data);
            }
          }
          const payLoad = {
            requestString: requestParams,
            requestHeaders: response.config.headers,
            responseString: response.data,
          };
          transactions({ metaData: queryParameters, payload: payLoad });
        }
      }
    } catch (error) {
      // Modify the requests only for Anthem Service Calls
      if (response.config && response.config.api) {
        if (
          response.config.url &&
          response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/logging/transactions' &&
          response.config.url.toLowerCase().indexOf('anthem') > -1
        ) {
          const { userAndBrand } = commonStore;
          let transactionId = response.headers['meta-transid'];
          const appName = appBrand.payLoadData.appName;
          const channel = appBrand.payLoadData.channel;
          const interactionId = userAndBrand.user.interactionId;
          if (!transactionId) {
            transactionId =
              appBrand.payLoadData.transactionPrefix + userAndBrand.brand.code + '-' + appBrand.payLoadData.appName;
          }
          const queryParameters = {
            state: userAndBrand.brand.state,
            payer: userAndBrand.brand.payerName,
            brand: userAndBrand.brand.code,
            userId: userAndBrand.user.id,
            appName,
            channel,
            transactionId,
            interactionId,
            httpStatus: response.status,
            reqSentTime: response.config.headers['meta-request-sent-time'],
            respRcptTime: moment().format(),
            requestType: response.config.method,
            operationName: response.config.url,
          };
          let requestParam = '';
          if (response.config.params) {
            const isJson = typeof response.config.params === 'object';
            if (isJson) {
              requestParam = response.config.params;
            } else {
              requestParam = JSON.parse(response.config.params);
            }
          }
          if (response.config.data) {
            const isJson = typeof response.config.data === 'object';
            if (isJson) {
              requestParam = response.config.data;
            } else {
              requestParam = JSON.parse(response.config.data);
            }
          }
          const payLoad = {
            requestString: requestParam,
            requestHeaders: response.config.headers,
            responseString: response.data,
          };
          transactions({ metaData: queryParameters, payload: payLoad });
        }
      }
    }
    return response;
  },
  error => {
    if (error.response.config && error.response.config.api) {
      if (
        error.response.config.url &&
        error.response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/logging/transactions' &&
        error.response.config.url.toLowerCase().indexOf('anthem') > -1
      ) {
        const { userAndBrand } = commonStore;
        let transactionId = error.response.headers['meta-transid'];
        const appName = appBrand.payLoadData.appName;
        const channel = appBrand.payLoadData.channel;
        const interactionId = userAndBrand.user.interactionId;
        if (!transactionId) {
          transactionId =
            appBrand.payLoadData.transactionPrefix + userAndBrand.brand.code + '-' + appBrand.payLoadData.appName;
        }
        const queryParameters = {
          state: userAndBrand.brand.state,
          payer: userAndBrand.brand.payerName,
          brand: userAndBrand.brand.code,
          userId: userAndBrand.user.id,
          appName,
          channel,
          transactionId,
          interactionId,
          httpStatus: error.response.status,
          reqSentTime: error.response.config.headers['meta-request-sent-time'],
          respRcptTime: moment().format(),
          requestType: error.response.config.method,
          operationName: error.response.config.url,
        };
        let requestParam = '';
        if (error.response.config.params) {
          const isJson = typeof error.response.config.params === 'object';
          if (isJson) {
            requestParam = error.response.config.params;
          } else {
            requestParam = JSON.parse(error.response.config.params);
          }
        }
        if (error.response.config.data) {
          const isJson = typeof error.response.config.data === 'object';
          if (isJson) {
            requestParam = error.response.config.data;
          } else {
            requestParam = JSON.parse(error.response.config.data);
          }
        }
        const payLoad = {
          requestString: requestParam,
          requestHeaders: error.response.config.headers,
          responseString: error.response.data,
        };
        transactions({ metaData: queryParameters, payload: payLoad });
      }
    }
    return Promise.reject(error);
  }
);
